import { useEffect } from 'react';
import cn from 'clsx';
import { useAtom } from 'jotai';
import { makeStyles } from '@material-ui/styles';
import { ErrorBoundary } from 'react-error-boundary';
import { IsExpandedAppTool } from '../../../atoms/appToolsAtom';
import useIsMobile from '../../../../hooks/useIsMobile';
import { AppToolId } from '../../../types/appTools';
import AppToolsErrorMessage from '../../AppToolsErrorMessage/AppToolsErrorMessage';
import { onAppToolGeneralErrorHandler } from '../../../utils/ErrorHandler';

export interface IAppToolProps {
    selectedApp: AppToolId;
    appTool: AppToolId;
    isEnabled: boolean;
    isLoading: boolean;
    expandByDefault?: boolean;
}

const AppTool: React.FC<IAppToolProps> = ({
    children,
    selectedApp,
    appTool,
    isEnabled,
    isLoading,
    expandByDefault = false,
}) => {
    const classes = useStyles();

    const [isExpanded, setIsExpanded] = useAtom(IsExpandedAppTool);
    const isMobile = useIsMobile();

    useEffect(() => {
        if (!isLoading) {
            if (!isEnabled) {
                if (selectedApp === appTool && isExpanded) {
                    setIsExpanded(false);
                }
            } else {
                if (expandByDefault && !isExpanded && !isMobile) {
                    setIsExpanded(true);
                }
            }
        }
    }, [isEnabled, isLoading, expandByDefault, appTool, selectedApp]);

    return (
        <div
            className={cn(classes.app, {
                [classes.hideApp]: selectedApp !== appTool,
            })}
        >
            <ErrorBoundary
                FallbackComponent={AppToolsErrorMessage}
                onError={onAppToolGeneralErrorHandler}
            >
                {/* TODO: in the future we can replace null with generic loader */}
                {!!isEnabled && !isLoading ? children : null}
            </ErrorBoundary>
        </div>
    );
};

const useStyles = makeStyles(
    () => ({
        app: { height: '100%' },
        hideApp: {
            display: 'none',
        },
    }),
    {
        classNamePrefix: 'AppTool',
    }
);

export default AppTool;
